<template>
  <div :class="wrapClasses">
    <div :class="rowClasses">
      <div class="col-xs-12 col-md-7">
        <vue-markdown
          :source="offerPackage.CmsUpgradeOfferPackageDetail.Lede"
          class="inline-upgrade__lede"
        />
      </div>
      <div class="col-xs-12 col-md-5">
        <div
          class="inline-upgrade__button-wrap"
          href="#"
        >
          <button
            type="button"
            class="button inline-upgrade__button"
            @click.prevent="handleButtonClick"
          >Upgrade Now</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import GoogleAnalytics from '@Shared/lib/google-analytics'
import ResponsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints'

export default {
  name: 'InlineUpgrade',
  components: {
    VueMarkdown
  },
  mixins: [
    ResponsiveBreakpointsMixin
  ],
  props: {
    offerPackage: { type: Object, default: null },
    mode: { type: String, default: 'detail' }
  },
  computed: {
    wrapClasses () {
      return {
        'inline-upgrade__wrap': true,
        'inline-upgrade__wrap--mix': this.mode === 'mix'
      }
    },
    rowClasses () {
      return {
        row: true,
        'row--vertical-align': !this.isTabletOrLower
      }
    }
  },
  methods: {
    handleButtonClick () {
      GoogleAnalytics.trackEvent('Replacement Package', 'click', this.offerPackage.CatalogPackage.RetailName)

      let url = `${this.$store.state.catalogPageCommon.siteRoot}Catalog/Package/${this.offerPackage.UpgradeOfferPackageId}?LastName=${this.$store.state.catalogPageCommon.customerInfo.LastName}&PIN=${this.$store.state.catalogPageCommon.customerInfo.CustomerRef}`
      window.location.href = url
    }
  }
}
</script>

<style lang="scss">
.inline-upgrade {
  &__wrap {
    border-top: 1px solid #494949;
    border-bottom: 1px solid #494949;
    padding: 20px;
    background-color: #b790b7;
    margin: 10px -10px;

    &--mix {
      border: 1px solid #494949;
      margin-bottom: 0;
    }
  }

  &__lede {
    text-align: center;
    margin-bottom: 10px;

    & > * {
      color: #fff;
      margin-bottom: 0;
      font-size: 16px;
      font-family: $font-open-sans;
    }
  }

  &__button {
    font-family: $font-open-sans;
    line-height: 3em;
    height: auto;
    text-align: center;
    background-color: #fff;
    color: $grad-color-purple;
    font-size: 16px;

    &:hover {
      color: #fff;
      background-color: $grad-color-purple;
    }

    &-wrap {
      text-align: center;
    }
  }

  @media screen and (min-width: $screen-sm-min) {
    &__wrap {
      margin: 10px 0;
    }

    &__lede {
      & > * {
        font-size: 14px;
      }
    }
  }

  @media screen and (min-width: $screen-md-min) {
    &__wrap {
      padding: 20px;
      margin: 0 0 40px 0;
    }

    &__button {
      width: 100%;
    }

    &__lede {
      margin-bottom: 0;
    }
  }

  /* @media screen and (min-width: $screen-lg-min) {
  } */
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/InlineUpgrade.vue